module.exports = __webpack_public_path__ + "img/itx-text-superscript.3310f3ea.svg";